import ModerationList from "../../components/moderators/ModerationList"

export const ModeratorsPage = () => {

    return (
        <ModerationList></ModerationList>
    )
}